<script>
import 'animate.css';
import { getGroupInfo, getImgList, joinUsClub, selectArticleList, selectPlayerList } from "@/api/home";
import { ClubImageEnum } from "@/enums/clubImageEnum";
import { NodeIdEnum } from "@/enums/nodeIdEnum";
import { PROVINCE_DATA } from "@/enums/provinceCityEnum";

export default {
  name: 'ClubPage',
  computed: {
    ClubImageEnum() {
      return ClubImageEnum;
    },
    NodeIdEnum() {
      return NodeIdEnum;
    },
  },
  data() {
    return {
      loading: true,
      richTextContent: '',
      articleList: [],
      playerList: [],
      imageGroups: {
        [ClubImageEnum.CLUB_44.VALUE]: [],
        [ClubImageEnum.CLUB_45.VALUE]: [],
        [ClubImageEnum.CLUB_52.VALUE]: [],
        [ClubImageEnum.CLUB_53.VALUE]: [],
        [ClubImageEnum.CLUB_54.VALUE]: [],
        [ClubImageEnum.CLUB_55.VALUE]: [],
        [ClubImageEnum.CLUB_56.VALUE]: [],
        [ClubImageEnum.CLUB_57.VALUE]: [],
        [ClubImageEnum.CLUB_58.VALUE]: [],
        [ClubImageEnum.CLUB_59.VALUE]: [],
        [ClubImageEnum.CLUB_60.VALUE]: [],
      },
      form: {
        userName: '',
        userMobile: '',
        userExperience: '',
        province: '',
        city: '',
        userJoinMoney: '',
        acreage: '',
      },
      errors: {},
      provinces: PROVINCE_DATA,
      cityList: [],
      wowInstance: null,
    }
  },
  mounted() {
    // 仅在mounted中初始化，避免重复请求
    import('wow.js').then((module) => {
      const WOW = module.default;
      this.wowInstance = new WOW().init();
    });
    this.initPageData();
  },
  beforeUnmount() {
    if (this.wowInstance) {
      this.wowInstance.destroy();
      this.wowInstance = null;
    }
  },
  methods: {
    async initPageData() {
      try {
        this.loading = true;
        await Promise.all([
          this.fetchImages(),
          this.fetchGroupInfo(),
          this.fetchPlayerList(),
          this.fetchArticleList()
        ]);
      } catch (error) {
        console.error("页面初始化数据加载失败:", error);
        this.$message?.error("页面数据加载失败，请刷新重试");
      } finally {
        this.loading = false;
      }
    },

    async fetchImages() {
      const typeStr = Object.keys(this.imageGroups).join(',');
      const res = await getImgList(typeStr);
      const dataList = res.data || [];

      Object.keys(this.imageGroups).forEach(classify => {
        this.imageGroups[classify] = dataList.filter(item => item.classify === classify && item.src);
      });
    },

    async fetchGroupInfo() {
      const type = 'club_about_us';
      const res = await getGroupInfo(type);
      if (res.code === 200 && res.data && res.data.length > 0) {
        this.richTextContent = res.data[0].richText || "";
      } else {
        this.richTextContent = "";
        if (res.msg) this.$message.error(res.msg);
      }
    },

    async fetchPlayerList() {
      const res = await selectPlayerList();
      if (res.code === 200) {
        this.playerList = res.data.rows || [];
      } else {
        this.$message.error(res.msg || "获取球员列表失败");
      }
    },

    async fetchArticleList() {
      const res = await selectArticleList(NodeIdEnum.ARTICLE_TYPE_XWDT_ID.value, 1, 3);
      if (res.code === 200) {
        this.articleList = res.data.rows || [];
      } else {
        this.$message.error(res.msg || "获取文章列表失败");
      }
    },

    onPlayerClick(playerId) {
      this.$router.push({
        path: "/playerDetail",
        query: { playerId, type: "club" }
      });
    },

    handleArticleClick(item) {
      this.$router.push({
        path: "/article",
        query: { articleId: item.id, type: item.type }
      });
    },

    async handleSubmit() {
      this.errors = {};

      // 表单校验
      const requiredFields = [
        { key: 'userName', msg: '请输入您的姓名' },
        { key: 'userMobile', msg: '请输入您的联系方式' },
        { key: 'userExperience', msg: '请简单描述您对台球行业的认知' },
        { key: 'province', msg: '请选择投资省份' },
        { key: 'city', msg: '请选择投资城市' },
        { key: 'userJoinMoney', msg: '请选择投资预算' },
        { key: 'acreage', msg: '请选择投资面积' },
      ];

      requiredFields.forEach(({ key, msg }) => {
        if (!this.form[key]) {
          this.errors[key] = msg;
        }
      });

      if (Object.keys(this.errors).length > 0) {
        this.$message.error('表单信息填写不完整，请检查并修正！');
        return;
      }

      // 手机号校验
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (this.form.userMobile && !phoneRegex.test(this.form.userMobile)) {
        this.$message.error('请输入有效的手机号');
        return;
      }

      try {
        const payload = {
          ...this.form,
          userJoinAddress: `${this.form.province || ''}${this.form.city || ''}`
        };

        console.log('准备提交的数据:', JSON.stringify(payload));
        const res = await joinUsClub(payload);
        if (res.code === 200) {
          this.$message.success('申请提交成功！我们会尽快与您联系。');
          // 重置表单
          this.form = {
            userName: '',
            userMobile: '',
            userExperience: '',
            province: '',
            city: '',
            userJoinMoney: '',
            acreage: '',
          };
          this.cityList = [];
        } else {
          this.$message.error(res.msg || '提交失败，请稍后重试');
        }
      } catch (error) {
        console.error("提交加盟申请失败:", error);
        this.$message.error('网络异常，提交失败');
      }
    },

    updateCityList() {
      const targetProvince = this.provinces.find((item) => item.name === this.form.province);
      this.cityList = targetProvince ? targetProvince.cities : [];
      this.form.city = "";
    },
  }
}
</script>

<template>
  <!-- hidden-sm-and-up：仅移动端显示，无需媒体查询 -->
  <div class="container-club hidden-sm-and-up" v-loading="loading">
    <!-- 顶部banner图 -->
    <div class="inside-banner">
      <el-carousel class="banner-carousel" loop autoplay>
        <el-carousel-item v-for="item in imageGroups[ClubImageEnum.CLUB_44.VALUE]" :key="item.id || item.src">
          <img :src="item.src" :alt="item.title" class="carousel-img" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 诚邀加盟 - 核心：container 100% + 标题居中 + 两行两列等宽 -->
    <div class="jdian-content-1">
      <div class="container">
        <div class="content-box-1">
          <div class="tag-title wow animate__animated animate__fadeInDown">
            <span>璟点台球俱乐部 / 智慧球房新体验</span>
            <strong>诚邀您的加盟</strong>
          </div>
          <ul>
            <li class="wow animate__animated animate__fadeInUp" v-for="item in imageGroups[ClubImageEnum.CLUB_45.VALUE]" :key="item.id || item.src">
              <div><img :src="item.src" :alt="item.title"></div>
              <p>{{ item.title }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 扶持政策 -->
    <div class="container jdian-content-2">
      <div class="support-top">
        <div class="fr wow animate__animated animate__fadeInRight">
          <img v-if="imageGroups[ClubImageEnum.CLUB_53.VALUE]?.[0]" :src="imageGroups[ClubImageEnum.CLUB_53.VALUE][0].src" :alt="imageGroups[ClubImageEnum.CLUB_53.VALUE][0].title">
        </div>
        <div class="clearfix"></div>
      </div>
      <ul>
        <li>
          <div>
            <img v-if="imageGroups[ClubImageEnum.CLUB_54.VALUE]?.[0]" :src="imageGroups[ClubImageEnum.CLUB_54.VALUE][0].src" :alt="imageGroups[ClubImageEnum.CLUB_54.VALUE][0].title">
          </div>
        </li>
      </ul>
    </div>

    <!-- 球馆设计 -->
    <div class="jdian-content-3">
      <div class="jdian-title wow animate__animated animate__fadeInDown">
        <strong>GYMNASIUM &nbsp; DESIGN</strong>
        <h2>球馆设计</h2>
      </div>
      <div class="gymnasium-box">
        <div class="gymnasium-slide">
          <div class="swiper-slide">
            <el-carousel
                :interval="4000"
                indicator-position="bottom"
                arrow="hover"
                class="custom-active-carousel"
                height="200px"
            >
              <el-carousel-item v-for="item in imageGroups[ClubImageEnum.CLUB_55.VALUE]" :key="item.id || item.src">
                <img class="carousel-img" :src="item.src" :alt="item.title">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>

    <!-- 关于我们 -->
    <div class="container jdian-content-4" id="about">
      <div class="jdian-title wow animate__animated animate__fadeInDown">
        <strong>ABOUT &nbsp;US</strong>
        <h2>关于我们</h2>
      </div>
      <div class="about-box">
        <div class="fl wow animate__animated animate__fadeInLeft">
          <img v-if="imageGroups[ClubImageEnum.CLUB_56.VALUE]?.[0]" :src="imageGroups[ClubImageEnum.CLUB_56.VALUE][0].src" :alt="imageGroups[ClubImageEnum.CLUB_56.VALUE][0].title">
        </div>
        <div class="fr wow animate__animated animate__fadeInRight">
          <img v-if="imageGroups[ClubImageEnum.CLUB_56.VALUE]?.[1]" :src="imageGroups[ClubImageEnum.CLUB_56.VALUE][1].src" :alt="imageGroups[ClubImageEnum.CLUB_56.VALUE][1].title">
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="about-container">
        <div class="about-container-content" v-html="richTextContent"></div>
      </div>
    </div>

    <!-- 签约球员 -->
    <div class="jdian-content-5" id="player">
      <div class="jdian-title-2 wow animate__animated animate__fadeInDown">签/约/球/员<span>Contract player</span></div>
      <div class="player-box container">
        <div class="swiper-container player-slide">
          <div class="swiper-slide">
            <el-carousel
                :interval="4000"
                indicator-position="bottom"
                arrow="hover"
                class="custom-active-carousel"
                height="450px"
            >
              <el-carousel-item v-for="item in playerList" :key="item.id">
                <img class="player-card-img" @click="onPlayerClick(item.id)" :src="item.fileEchoVo.url" :alt="item.name">
                <p class="player-name">{{ item.name }}</p>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>

    <!-- 新闻动态 -->
    <div class="container jdian-content-6" id="nifor">
      <div class="jdian-title-2 wow animate__animated animate__fadeInDown">新/闻/动/态<span>News Update</span></div>
      <ul class="wow animate__animated animate__fadeInUp">
        <li style="cursor: pointer" v-for="item in articleList" :key="item.id" @click="handleArticleClick(item)">
          <div>
            <div class="fl"><img class="fl" :src="item.thumbnail" :alt="item.title"></div>
            <div class="right-content">
              <span style="font-weight: 600">{{ item.title }}</span>
              <span class="nowrap">{{ item.time.substring(0, 10) }}</span>
            </div>
            <div class="clearfix"></div>
          </div>
        </li>
      </ul>
      <div class="pagination">
        <a class="more" :href="`/articleHome?articleType=${NodeIdEnum.ARTICLE_TYPE_XWDT_ID.value}`" target="_blank">查看更多</a>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="jdian-content-7" id="partner">
      <div class="container">
        <div class="jdian-title-2 wow animate__animated animate__fadeInDown">战/略/合/作/伙/伴<span>Strategic Partners</span></div>
        <ul class="wow animate__animated animate__fadeInUp">
          <li v-for="item in imageGroups[ClubImageEnum.CLUB_57.VALUE]" :key="item.id || item.src">
            <a v-if="item.url" :href="item.url" target="_blank" :title="item.title">
              <img style="cursor: pointer" :src="item.src" :alt="item.title">
            </a>
            <img v-else style="cursor: pointer" :src="item.src" :alt="item.title">
          </li>
        </ul>
      </div>
    </div>

    <!-- 招商合作 -->
    <div class="jdian-content-8">
      <div class="jdian-title wow animate__animated animate__fadeInDown">
        <strong>INVESTMENT COOPERATION &nbsp;US</strong>
        <h2>招商合作</h2>
      </div>
      <div class="container join-advantage">
        <div class="jdian-title-2">联/名/店/优/势<span>Advantages of joint stores</span></div>
        <ul>
          <li v-for="(item, index) in imageGroups[ClubImageEnum.CLUB_58.VALUE].slice(0, 8)" :key="index">
            <img :src="item.src" :alt="item.title">
            <strong v-if="index != 0">{{ item.title }}</strong>
            <p v-if="index != 0">{{ item.description }}</p>
          </li>
        </ul>
        <div class="adv-bot">
          <ul>
            <li class="fl">
              <img v-if="imageGroups[ClubImageEnum.CLUB_58.VALUE]?.[8]" :src="imageGroups[ClubImageEnum.CLUB_58.VALUE][8].src" :alt="imageGroups[ClubImageEnum.CLUB_58.VALUE][8].title">
              <strong v-if="imageGroups[ClubImageEnum.CLUB_58.VALUE]?.[8]">{{ imageGroups[ClubImageEnum.CLUB_58.VALUE][8].title }}</strong>
            </li>
            <li class="fr">
              <p v-if="imageGroups[ClubImageEnum.CLUB_58.VALUE]?.[8]" :style="{ whiteSpace: 'pre-line' }">
                {{ imageGroups[ClubImageEnum.CLUB_58.VALUE][8].description.replace(/；/g, '\n') }}
              </p>
            </li>
          </ul>
        </div>
      </div>

      <!-- 加盟条件 -->
      <div class="join-admission">
        <div class="fl aleft wow animate__animated animate__fadeInLeft">
          <img v-if="imageGroups[ClubImageEnum.CLUB_59.VALUE]?.[0]" :src="imageGroups[ClubImageEnum.CLUB_59.VALUE][0].src" :alt="imageGroups[ClubImageEnum.CLUB_59.VALUE][0].title">
        </div>
        <div class="fl aright wow animate__animated animate__fadeInRight">
          <img v-if="imageGroups[ClubImageEnum.CLUB_59.VALUE]?.[1]" :src="imageGroups[ClubImageEnum.CLUB_59.VALUE][1].src" :alt="imageGroups[ClubImageEnum.CLUB_59.VALUE][1].title">
        </div>
      </div>

      <!-- 加盟流程 -->
      <div class="join-process">
        <div class="process-box">
          <div class="jdian-title-2 wow animate__animated animate__fadeInRight">门/店/开/业/流/程<span>Store opening process</span></div>
          <img v-if="imageGroups[ClubImageEnum.CLUB_60.VALUE]?.[0]" :src="imageGroups[ClubImageEnum.CLUB_60.VALUE][0].src" :alt="imageGroups[ClubImageEnum.CLUB_60.VALUE][0].title">
        </div>
      </div>

      <!-- 加盟申请 -->
<!--      <div class="join-bg">-->
<!--        <div class="container wow animate__animated animate__fadeInRight">-->
<!--          <strong>加盟璟点台球</strong>-->
<!--          <span>和我们一起做一个伟大的事业</span>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="container join-application">-->
<!--        <div class="jdian-title-2">加/盟/申/请<span>Application for joining</span></div>-->
<!--        <div class="join-form">-->
<!--          <div class="form-group">-->
<!--            <span>您的姓名：</span>-->
<!--            <el-input type="text" v-model="form.userName" required />-->
<!--          </div>-->
<!--          <div class="form-group">-->
<!--            <span>联系方式：</span>-->
<!--            <el-input type="text" v-model="form.userMobile" maxlength="11" required />-->
<!--          </div>-->
<!--          <div class="form-group message">-->
<!--            <span>行业认知：</span>-->
<!--            <el-input type="textarea" v-model="form.userExperience" placeholder="请您简单讲讲，自己对于台球行业的了解（例如，您的球龄、球杆品牌、是否有台球从业经验等）"></el-input>-->
<!--          </div>-->
<!--          <div class="form-group">-->
<!--            <span>投资城市：</span>-->
<!--            <div class="info">-->
<!--              <div>-->
<!--                <el-select v-model="form.province" placeholder="选择省份" @change="updateCityList">-->
<!--                  <el-option-->
<!--                      v-for="(item, index) in provinces"-->
<!--                      :key="index"-->
<!--                      :label="item.name"-->
<!--                      :value="item.name"-->
<!--                  ></el-option>-->
<!--                </el-select>-->
<!--                <el-select v-model="form.city" placeholder="选择城市" :disabled="!form.province">-->
<!--                  <el-option-->
<!--                      v-for="(item, index) in cityList"-->
<!--                      :key="index"-->
<!--                      :label="item"-->
<!--                      :value="item"-->
<!--                  ></el-option>-->
<!--                </el-select>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="form-group">-->
<!--            <span>投资预算：</span>-->
<!--            <label v-for="money in ['10-30万', '31-80万', '81-130万', '131-180万', '181万以上']" :key="money">-->
<!--              <input type="radio" v-model="form.userJoinMoney" :value="money"> {{ money }}-->
<!--            </label>-->
<!--          </div>-->
<!--          <div class="form-group">-->
<!--            <span>投资面积：</span>-->
<!--            <label v-for="area in ['100~300m²', '301~500m²', '501~700m²', '701~1000m²', '1000m²以上']" :key="area">-->
<!--              <input type="radio" v-model="form.acreage" :value="area"> {{ area }}-->
<!--            </label>-->
<!--          </div>-->
<!--          <div class="form-submit">-->
<!--            <input type="button" value="提交申请" @click="handleSubmit">-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<style scoped lang="scss">
// 全局基础样式 - 移动端原生，无需媒体查询
.container-club {
  width: 100% !important;
  margin: 0 auto !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  background: #ecebf0 !important;
}

.fl {
  float: left !important;
}

.fr {
  float: right !important;
}

.nowrap {
  overflow: hidden !important;
  -o-text-overflow: ellipsis !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.clearfix::after {
  content: "" !important;
  display: table !important;
  clear: both !important;
}

// 1. 顶部Banner - 移动端原生样式
.inside-banner {
  position: relative !important;
  margin-top: 60px !important;
  width: 100% !important;
  overflow: hidden !important;

  .banner-carousel {
    width: 100% !important;
    @media (max-width: 768px) {
      height: 120px !important;
    }
    :deep(.el-carousel__container) {
      height: 100% !important;
    }

    :deep(.el-carousel-item) {
      height: 100% !important;
    }
  }

  .carousel-img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    object-position: center !important;
  }
}

// 2. 核心：诚邀加盟模块 - container 100% + 标题居中 + 两行两列等宽
.jdian-content-1 {
  @media (max-width: 768px) {
    padding-top: 30px !important;
    padding-bottom: 30px !important;
    border-bottom: 20px solid #f6c279 !important;
  }
  background: url('../../../assets/img/club/club_bg.jpg') no-repeat center !important;
  background-size: cover !important;

  .container {
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box !important;
  }

  .content-box-1 {
    width: 100% !important;
    @media (max-width: 768px) {
      padding: 0 10px !important;
    }
    box-sizing: border-box !important;
  }

  // 标题完全居中
  .tag-title {
    width: 100% !important;
    text-align: center !important;
    @media (max-width: 768px) {
      margin-bottom: 40px !important;
    }
    padding: 0 !important;
    position: relative !important;

    &::before {
      position: absolute !important;
      content: '' !important;
      @media (max-width: 768px) {
        top: -15px !important;
        left: 50% !important;
        width: 36px !important;
        margin-left: -18px !important;
        border-top: 2px solid #fff !important;
      }
    }

    span {
      @media (max-width: 768px) {
        font-size: 16px !important;
      }
      color: #fff !important;
      display: block !important;
      text-align: center !important;
      letter-spacing: 1px !important;
      margin: 0 auto !important;
    }

    strong {
      @media (max-width: 768px) {
        font-size: 24px !important;
      }
      color: #f6c279 !important;
      display: block !important;
      text-align: center !important;
      margin-top: 5px !important;
      letter-spacing: 1px !important;
      margin: 5px auto 0 auto !important;
    }
  }

  // 两行两列等宽 - Grid布局
  ul {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    grid-gap: 15px !important;
    padding: 0 10px !important;
    margin: 0 !important;
    width: 100% !important;
    list-style: none !important;
    box-sizing: border-box !important;

    li {
      width: 100% !important;
      min-width: 0 !important;
      padding: 10px !important;
      margin: 0 !important;
      float: none !important;
      text-align: center !important;
      background: rgba(239, 239, 239, 0.87) !important;
      box-sizing: border-box !important;
      border-radius: 8px !important;

      div {
        width: 100% !important;
        @media (max-width: 768px) {
          height: 120px !important;
          padding: 0 !important;
          line-height: 120px !important;
        }

        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        box-sizing: border-box !important;
      }

      img {
        display: inline-block !important;
        width: 70%;
        vertical-align: middle !important;
      }

      p {
        @media (max-width: 768px) {
          padding: 8px !important;
          font-size: 12px !important;
        }

        background: #f6c279 !important;
        color: #0a0a0a !important;
        margin: 0 !important;
        box-sizing: border-box !important;
        border-radius: 0 0 8px 8px !important;
      }
    }
  }
}

// 3. 通用容器 - 移动端100%宽度
.container {
  width: 100% !important;
  max-width: none !important;
  margin: 0 auto !important;
  padding: 0 10px !important;
  box-sizing: border-box !important;
}

// 4. 扶持政策模块
.jdian-content-2 {
  padding-top: 20px !important;
  max-width: none !important;

  .support-top {
    .fr {
      float: none !important;
      width: 100% !important;
      margin-bottom: 15px !important;

      img {
        width: 40% !important;
        height: auto !important;
        margin: 30px auto !important;
        display: block !important;
      }
    }
  }

  ul li div img {
    width: 100% !important;
    height: auto !important;
    border-radius: 8px !important;
  }
}

// 5. 球馆设计模块
.jdian-content-3 {
  @media (max-width: 768px) {
    padding: 20px 15px;
  }
  background: #222 !important;

  .jdian-title {
    text-align: center !important;
    margin-bottom: 20px !important;

    strong {
      display: block !important;
      color: #fff !important;
      letter-spacing: 1px !important;
      @media (max-width: 768px) {
        font-size: 24px !important;
      }
    }

    h2 {
      position: relative !important;

      @media (max-width: 768px) {
        font-size: 22px !important;
        margin-top: 15px !important;
      }
      font-weight: normal !important;
      letter-spacing: 1px !important;
      color: #fff !important;

      &::before {
        position: absolute !important;
        content: '' !important;
        @media (max-width: 768px) {
          left: 50% !important;
          width: 48px !important;
          margin-left: -24px !important;
          border-top: 3px solid #f6c279 !important;
        }

      }
    }
  }

  .gymnasium-box {
    width: 100% !important;
    padding: 0 !important;
  }
}

// 6. 轮播通用样式 - 整铺显示
.custom-active-carousel {
  width: 100% !important;
  height: 280px !important;
  border-radius: 8px !important;
  overflow: hidden !important;

  :deep(.carousel-img) {
    object-fit: cover !important;
    width: 100% !important;
    height: 100% !important;
  }

  // 球员图片
  :deep(.player-card-img) {
    object-fit: cover !important;
    width: 100% !important;
    height: 100% !important;
  }

  // 球员名称
  .player-name {
    @media (max-width: 768px) {
      font-size: 20px !important;
      height: 60px;
      line-height: 60px;
    }
    text-align: center !important;
    color: #222 !important;
    text-shadow: 0 0 5px rgba(0, 0, 0, 0.5) !important;
  }

  // 指示器
  :deep(.el-carousel__indicators) {
    bottom: 10px !important;
  }

  :deep(.el-carousel__indicator) {
    width: 8px !important;
    height: 8px !important;
    margin: 0 4px !important;
  }

  // 箭头
  :deep(.el-carousel__arrow) {
    width: 30px !important;
    height: 30px !important;
    font-size: 14px !important;
    background: rgba(0, 0, 0, 0.3) !important;
    color: #fff !important;
    border-radius: 50% !important;
  }

  :deep(.el-carousel__mask) {
    background: none !important;
  }
}

// 7. 关于我们模块
.jdian-content-4 {
  @media (max-width: 768px) {
    padding: 40px 15px !important;
  }

  max-width: none !important;
  background: #ecebf0 !important;

  .jdian-title {
    text-align: center !important;
    @media (max-width: 768px) {
      margin-bottom: 20px !important;
    }

    strong {
      display: block !important;
      @media (max-width: 768px) {
        font-size: 24px !important;
      }
      color: #222 !important;
      letter-spacing: 1px !important;
    }

    h2 {
      position: relative !important;
      @media (max-width: 768px) {
        font-size: 22px !important;
        margin-top: 15px !important;
      }

      font-weight: normal !important;
      letter-spacing: 1px !important;
      color: #222 !important;

      &::before {
        position: absolute !important;
        content: '' !important;
        @media (max-width: 768px) {
          left: 50% !important;
          width: 48px !important;
          margin-left: -24px !important;
          border-top: 3px solid #f6c279 !important;
        }

      }
    }
  }

  .about-box {
    .fl, .fr {
      float: none !important;
      width: 100% !important;
      margin-bottom: 15px !important;

      img {
        width: 100% !important;
        height: auto !important;
        border-radius: 8px !important;
      }
    }
  }

  .about-container {
    @media (max-width: 768px) {
      margin-top: 20px !important;
    }

  }

  ::v-deep(.about-container-content) {

    color: #333 !important;
    box-sizing: border-box !important;

    p {
      @media (max-width: 768px) {
        font-size: 16px !important;
        line-height: 30px !important;
        margin: 10px 0 !important;
      }

    }

    img {
      width: 100% !important;
      height: auto !important;
      margin: 10px auto !important;
      border-radius: 8px !important;
      display: block !important;
    }
  }
}

// 8. 签约球员模块
.jdian-content-5 {
  padding-bottom: 20px !important;
  background: #d2d2d2 !important;
  overflow: hidden !important;

  .jdian-title-2 {
    width: 100% !important;
    @media (max-width: 768px) {
      height: 45px !important;
      margin: 0 auto 20px auto !important;
      line-height: 45px !important;
      font-size: 16px !important;
    }
    background: #f6c279 !important;
    text-align: center !important;
    letter-spacing: 1px !important;
    font-weight: bold !important;

    span {
      @media (max-width: 768px) {
        font-size: 12px !important;
      }
      font-weight: normal !important;
    }
  }

  .player-box {
    padding: 0 !important;
  }
}

// 9. 新闻动态模块 - 核心修改
.jdian-content-6 {
  @media (max-width: 768px) {
    padding: 20px 0 !important;
  }
  background: #fff !important;
  overflow: hidden !important;

  .jdian-title-2 {
    @media (max-width: 768px) {
      height: 45px !important;
      margin: 0 auto 20px auto !important;
      line-height: 45px !important;
      font-size: 16px !important;
    }
    width: 100% !important;
    background: #f6c279 !important;
    text-align: center !important;
    letter-spacing: 1px !important;
    font-weight: bold !important;

    span {
      @media (max-width: 768px) {
        font-size: 12px !important;
      }
      font-weight: normal !important;
    }
  }

  ul {
    @media (max-width: 768px) {
      padding: 0 10px !important;
      margin: 0 !important;

      li {
        margin-bottom: 15px !important;
        list-style: none !important;
        background: #f8f8f8 !important;
        border-radius: 8px !important;
        overflow: hidden !important;
        padding: 10px !important;

        div {
          // 恢复图片左浮动并设置宽度
          .fl {
            float: left !important;
            width: 40% !important;
            margin-bottom: 0 !important;
            height: 90px !important;

            img {
              width: 100% !important;
              height: 100% !important;
              object-fit: cover !important;
              border-radius: 8px !important;
            }
          }

          // 恢复文字右浮动并设置宽度
          .right-content {
            float: right !important;
            width: 55% !important;
            font-size: 13px !important;
            padding-left: 5% !important;
            box-sizing: border-box !important;

            span {
              font-size: 12px !important;
              display: block !important;
              margin: 0 0 5px 0 !important;
              line-height: 1.2 !important;
            }

            i {
              display: block !important;
              margin: 5px 0 !important;
              color: #999 !important;
            }

            p {
              font-size: 11px !important;
              line-height: 1.4 !important;
              color: #666 !important;
              display: -webkit-box !important;
              -webkit-line-clamp: 2 !important;
              -webkit-box-orient: vertical !important;
              overflow: hidden !important;
              margin: 0 !important;
            }
          }
        }
      }
    }
  }

  .pagination {
    text-align: center !important;
    margin-top: 20px !important;

    .more {
      @media (max-width: 768px) {
        display: block !important;
        width: 70% !important;
        height: 45px !important;
        line-height: 45px !important;
        color: #fff !important;
        font-size: 16px !important;
        background: #d26b6b !important;
        letter-spacing: 1px !important;
        border-radius: 8px !important;
        text-decoration: none !important;
        transition: all 0.26s !important;
      }
    }

    .more:hover {
      background: #c15a5a !important;
    }
  }
}

// 10. 合作伙伴模块
.jdian-content-7 {
  @media (max-width: 768px) {
    padding-bottom: 20px !important;
    background: #222 !important;
    overflow: hidden !important;

    .jdian-title-2 {
      width: 100% !important;
      height: 45px !important;
      margin: 0 auto 20px auto !important;
      line-height: 45px !important;
      background: #f6c279 !important;
      font-size: 16px !important;
      text-align: center !important;
      letter-spacing: 1px !important;
      font-weight: bold !important;
      color: #222;

      span {
        font-size: 12px !important;
        font-weight: normal !important;
      }
    }

    ul {
      display: grid !important;
      grid-template-columns: repeat(2, 1fr) !important;
      grid-gap: 15px !important;
      padding: 0 10px !important;
      margin: 0 !important;

      li {
        width: 100% !important;
        padding: 10px !important;
        list-style: none !important;
        background: #333 !important;
        border-radius: 8px !important;
        text-align: center !important;

        img {
          max-width: 80% !important;
          max-height: 80px !important;
          margin: 0 auto !important;
          display: block !important;
        }
      }
    }
  }
}

// 11. 招商合作模块
.jdian-content-8 {
  @media (max-width: 768px) {
    padding: 20px 0 !important;
    background: #fff !important;

    .jdian-title {
      text-align: center !important;
      margin-bottom: 20px !important;

      strong {
        display: block !important;
        font-size: 14px !important;
        color: #222 !important;
        letter-spacing: 1px !important;
      }

      h2 {
        position: relative !important;
        margin-top: 15px !important;
        font-size: 18px !important;
        font-weight: normal !important;
        letter-spacing: 1px !important;
        color: #222 !important;

        &::before {
          position: absolute !important;
          content: '' !important;
          top: -15px !important;
          left: 50% !important;
          width: 48px !important;
          margin-left: -24px !important;
          border-top: 3px solid #f6c279 !important;
        }
      }
    }
  }

  .join-advantage {
    @media (max-width: 768px) {
      background: #fff !important;
      overflow: hidden !important;

      .jdian-title-2 {
        width: 100% !important;
        height: 45px !important;
        line-height: 45px !important;
        background: #f6c279 !important;
        font-size: 16px !important;
        text-align: center !important;
        letter-spacing: 1px !important;
        font-weight: bold !important;
        margin-bottom: 0 !important;

        &::after{
          border: none;
        }

        span {
          font-size: 12px !important;
          font-weight: normal !important;
        }
      }

      ul {
        display: grid !important;
        grid-template-columns: repeat(2, 1fr) !important;
        grid-gap: 10px !important;
        padding: 10px !important;
        margin: 0 !important;

        li {
          padding: 10px !important;
          text-align: center !important;
          border-bottom: 1px solid #ddd !important;
          border-right: 1px solid #ddd !important;
          list-style: none !important;
          width: 100%;
          height: 240px;

          img {
            max-width: 80% !important;
            max-height: 150px !important;
            margin: 0 auto !important;
            display: block !important;
          }

          strong {
            font-size: 12px !important;
            margin-top: 8px !important;
            display: block !important;
          }

          p {
            height: auto;
            font-size: 11px !important;
            line-height: 20px !important;
            margin-top: 10px !important;
          }
        }
      }

      .adv-bot {
        border-bottom: 5px solid #f6c279 !important;
        overflow: hidden !important;

        ul {
          display: block !important;
          padding: 10px !important;

          li:first-child {
            height: 120px;
          }
          li {
            float: none !important;
            width: 100% !important;
            margin-bottom: 10px !important;
            border: none !important;
            padding: 10px !important;
            img {
              max-width: 80% !important;
              max-height: 80px !important;
              margin: 0 auto !important;
              display: block !important;
            }

            strong {
              font-size: 14px !important;
              text-align: center !important;
              display: block !important;
              margin-top: 8px !important;
            }

            p {
              font-size: 12px !important;
              line-height: 24px !important;
              text-align: left !important;
              margin-top: 10px !important;
            }
          }
        }
      }
    }
  }

  .join-admission {
    position: relative !important;
    margin-top: 20px !important;
    overflow: hidden !important;

    .aleft, .aright {
      float: none !important;
      width: 100% !important;
      margin-bottom: 15px !important;

      img {
        width: 100% !important;
        height: auto !important;
        border-radius: 8px !important;
      }
    }
  }

  .join-process {
      position: relative !important;
      padding: 0 10px !important;
      padding-bottom: 15px !important;
      background: #fff !important;
      margin-top: 20px !important;
      &::before{
        height: 0;
      }

      .process-box {
        @media (max-width: 768px) {
          padding: 10px !important;
          background: #eeedf2 !important;
          overflow: hidden !important;
          border-radius: 8px !important;

          .jdian-title-2 {
            float: none !important;
            width: 100% !important;
            height: 45px !important;
            line-height: 45px !important;
            background: #f6c279 !important;
            font-size: 16px !important;
            text-align: center !important;
            letter-spacing: 1px !important;
            font-weight: bold !important;
            margin-bottom: 10px !important;
            padding: 0 !important;

            span {
              font-size: 12px !important;
              font-weight: normal !important;
            }
          }

          img {
            width: 100% !important;
            height: auto !important;
          }
        }
    }
  }

  .join-bg {
    padding: 20px 0 !important;
    background: url('../../../assets/img/club/club_bg_2.jpg') center no-repeat !important;
    background-size: cover !important;
    margin-top: 20px !important;
    border-radius: 8px !important;

    .container {
      padding: 0 20px !important;
    }

    strong {
      position: relative !important;
      display: block !important;
      padding-top: 15px !important;
      font-size: 18px !important;
      letter-spacing: 5px !important;
      color: #fff !important;
      text-align: center !important;

      &::before {
        position: absolute !important;
        content: '' !important;
        top: 0 !important;
        left: 50% !important;
        width: 36px !important;
        margin-left: -18px !important;
        border-top: 3px solid #f6c279 !important;
      }
    }

    span {
      display: block !important;
      margin-top: 5px !important;
      font-size: 16px !important;
      color: #fff !important;
      letter-spacing: 3px !important;
      text-align: center !important;
    }
  }

  .join-application {
    padding: 20px 0 !important;

    .jdian-title-2 {
      width: 100% !important;
      height: 45px !important;
      line-height: 45px !important;
      background: #f6c279 !important;
      font-size: 16px !important;
      text-align: center !important;
      letter-spacing: 1px !important;
      font-weight: bold !important;
      border-radius: 8px !important;
      margin-bottom: 20px !important;
      padding: 0 !important;

      span {
        display: block !important;
        font-size: 12px !important;
        font-weight: normal !important;
        margin-top: -5px !important;
      }
    }

    .join-form {
      .form-group {
        position: relative !important;
        height: 45px !important;
        margin-top: 15px !important;
        border: 1px solid #ccc !important;
        padding: 0 !important;
        background: #fff !important;
        overflow: hidden !important;
        line-height: 45px !important;
        border-radius: 8px !important;

        span {
          position: relative !important;
          display: block !important;
          width: 100% !important;
          text-align: left !important;
          font-size: 14px !important;
          letter-spacing: 1px !important;
          padding: 0 10px !important;
          box-sizing: border-box !important;
          border-bottom: 1px solid #eee !important;
        }

        &.message {
          height: 120px !important;

          span {
            border-bottom: none !important;
          }
        }

        > input, textarea {
          width: 100% !important;
          padding: 0 10px !important;
          font-size: 14px !important;
          line-height: 45px !important;
          color: #444 !important;
          border: none !important;
          box-sizing: border-box !important;
        }

        textarea {
          max-height: 100% !important;
          line-height: 22px !important;
          padding: 10px !important;
          height: 100% !important;
        }

        label {
          display: inline-flex !important;
          align-items: center !important;
          margin-right: 10px !important;
          font-size: 12px !important;

          input {
            margin-right: 5px !important;
            width: 16px !important;
            height: 16px !important;
          }
        }

        .info {
          div {
            display: flex !important;
            flex-direction: column !important;
            gap: 10px !important;
            padding: 0 10px !important;

            :deep(.el-select) {
              width: 100% !important;
            }
          }
        }
      }

      .form-submit {
        text-align: center !important;
        margin-top: 20px !important;

        input {
          display: block !important;
          width: 100% !important;
          height: 48px !important;
          line-height: 48px !important;
          background: #f6c279 !important;
          cursor: pointer !important;
          border-radius: 8px !important;
          font-size: 16px !important;
          letter-spacing: 1px !important;
          border: none !important;
          color: #fff !important;
        }

        input:hover {
          background: #e5a75a !important;
        }
      }
    }
  }
}

// Element UI 组件样式穿透 - 全局覆盖
:deep(.el-input__inner) {
  border: none !important;
  font-size: 14px !important;
  height: 45px !important;
  line-height: 45px !important;
  padding: 0 15px !important;
  background: #f8f8f8 !important;
  border-radius: 4px !important;
}

:deep(.el-textarea__inner) {
  border: none !important;
  font-size: 14px !important;
  height: auto !important;
  min-height: 100px !important;
  padding: 10px 15px !important;
  background: #f8f8f8 !important;
  border-radius: 4px !important;
  line-height: 22px !important;
}

:deep(.el-select__inner) {
  border: none !important;
  font-size: 14px !important;
  height: 45px !important;
  line-height: 45px !important;
  padding: 0 15px !important;
  background: #f8f8f8 !important;
  border-radius: 4px !important;
}

:deep(.el-carousel) {
  width: 100% !important;
  height: 100% !important;
}
</style>